export class ReporteDevolucion {

 
public  idCompania: string;
public  idVisita: string;
public  idTarea: string;
public  tipoTarea: string;
public  numeroDocumento: string;
public  numeroOrden: string;
public  clasificacion: string;
public  codigo: string;
public  descripcion: string;
public  cantidad: string;
public  cantidadConfirmada: string;
public  observaciones: string;
public  fechaInicio: string;
public  fechaFin: string;
public  motivo: string;
public idPunto: string;
public nombrePunto: string;
public direccion: string;

//articulo

public   codigoArticulo: string;
public  presentacion: string;
public  descripcionArticulo: string;
public  codigoBarrasUd: string;
public  codigoBarrasCj: string;
}